module.exports = __webpack_public_path__ + "img/arrow_full_left_white.e58d567b.svg";